import {
  ROUTER_CARBON_ACCOUNT_MANAGEMENT_INSTITUTION,
  ROUTER_CARBON_ACCOUNT_MANAGEMENT_NON_PROJECT_LOAN,
  ROUTER_CARBON_ACCOUNT_MANAGEMENT_PROJECT_LOAN,
  ROUTER_CARBON_EMISSION_ACCOUNT_INSTITUTION,
  ROUTER_CARBON_EMISSION_ACCOUNT_NON_PROJECT_LOAN,
  ROUTER_CARBON_EMISSION_ACCOUNT_PROJECT_LOAN,
  ROUTER_CARBON_REDUCTION_ACCOUNT_NON_PROJECT_LOAN,
  ROUTER_CARBON_REDUCTION_ACCOUNT_PROJECT_LOAN,
  ROUTER_ENV_INFORMATION_DISCLOSURE,
  ROUTER_ENV_INFORMATION_DISCLOSURE_DETAIL,
  ROUTER_QUESTIONAIRE,
  ROUTER_RISK_SURVEY,
  ROUTER_CORPORATE,
  ROUTER_CREATE_PROJECT,


} from "./router";

export const EditPageRoute: {
  [property: string]: string;
} = {
  [ROUTER_CREATE_PROJECT]: ROUTER_CORPORATE,
  [ROUTER_CARBON_EMISSION_ACCOUNT_INSTITUTION]: ROUTER_CARBON_ACCOUNT_MANAGEMENT_INSTITUTION,
  [ROUTER_CARBON_EMISSION_ACCOUNT_PROJECT_LOAN]: ROUTER_CARBON_ACCOUNT_MANAGEMENT_PROJECT_LOAN,
  [ROUTER_CARBON_EMISSION_ACCOUNT_NON_PROJECT_LOAN]: ROUTER_CARBON_ACCOUNT_MANAGEMENT_NON_PROJECT_LOAN,
  [ROUTER_CARBON_REDUCTION_ACCOUNT_PROJECT_LOAN]: ROUTER_CARBON_ACCOUNT_MANAGEMENT_PROJECT_LOAN,
  [ROUTER_CARBON_REDUCTION_ACCOUNT_NON_PROJECT_LOAN]: ROUTER_CARBON_ACCOUNT_MANAGEMENT_NON_PROJECT_LOAN,
  [ROUTER_ENV_INFORMATION_DISCLOSURE_DETAIL]: ROUTER_ENV_INFORMATION_DISCLOSURE,
  [ROUTER_RISK_SURVEY]: ROUTER_QUESTIONAIRE,
};
